import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { AuthProvider, supabase } from '@shadeables/supabase';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@shadeables/ui';
import { StripeProvider, BillingProvider } from '@shadeables/billing';

const queryClient = new QueryClient();

// Environment variables for Stripe and Supabase
const STRIPE_PUBLISHABLE_KEY =
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '';
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || '';

const rootElement = document.getElementById('root');
if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <StripeProvider publishableKey={STRIPE_PUBLISHABLE_KEY}>
            <BillingProvider
              supabaseClient={supabase}
              supabaseUrl={SUPABASE_URL}
            >
              <ThemeProvider>
                <App />
              </ThemeProvider>
            </BillingProvider>
          </StripeProvider>
        </AuthProvider>
      </QueryClientProvider>
    </StrictMode>
  );
} else {
  console.error('Failed to find the root element');
}
